import Box from "@mui/material/Box";
import Image from "next/image";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";

const defaultSocials = [
  {
    key: "facebook",
    component: FacebookShareButton,
    icon: "/f-b.png",
    alt: "facebook",
  },
  {
    key: "linkedin",
    component: LinkedinShareButton,
    icon: "/l-b.png",
    alt: "linkedin",
  },
  {
    key: "twitter",
    component: TwitterShareButton,
    icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/twitter-2.svg",
    alt: "twitter",
  },
];

export default function ShareSocial({
  url,
  onCopy,
  extraSocials = [],
  size = 30,
  gap = 1,
  imgStyle = {},
  showCopy = true,
}) {
  if (!url) return null;

  const socials = [...defaultSocials, ...extraSocials];

  return (
    <Box sx={{ display: "flex", gap, alignItems: "center" }}>
      {socials.map(({ key, component: Component, icon, alt }) => (
        <Component key={key} url={url}>
          <Image
            src={icon}
            alt={alt}
            width={size}
            height={size}
            quality={75}
            style={imgStyle}
          />
        </Component>
      ))}

      {showCopy && (
        <Box onClick={onCopy} sx={{ cursor: "pointer" }}>
          <Image
            src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/pin-b.png"
            alt="copy-link"
            width={size}
            height={size}
            quality={75}
            style={imgStyle}
          />
        </Box>
      )}
    </Box>
  );
}
